
function _readEnumsFromLocalStorage() {
  let localStorageValue = localStorage["enumsData"];
  return localStorageValue ? JSON.parse(localStorageValue) : null;
}

let enums = _readEnumsFromLocalStorage();

// Re-syncs the in-memory cache from localStorage. Must be called after login (once enumsData
// has been refreshed for the logged-in user's locale) since this is an SPA and the module-level
// `enums` cache otherwise keeps serving labels from whichever locale was active on last load.
export function init() {
  enums = _readEnumsFromLocalStorage();
}

export const enumTypes =  {
  ALERT_TYPE:"ALERT_TYPE",
  ASSET_STATUS:"ASSET_STATUS",
  WORK_ORDER_STATUS:"WORK_ORDER_STATUS",
  WORK_ORDER_TASKS_STATUS:'WORK_ORDER_TASKS_STATUS',
  OBJECT_TYPE:"OBJECT_TYPE",
  IMPORT_TYPE:"IMPORT_TYPE",
  INSPECTION_STATUS:"INSPECTION_STATUS",
  CAPACITY_STATE:"CAPACITY_STATE",
  PRINCIPAL_STATUS: "PRINCIPAL_STATUS",
  DASHBOARD_TIME_PERIOD:"DASHBOARD_TIME_PERIOD",
  COMPARISON_PERIOD:"COMPARISON_PERIOD",
  DASHBOARD_WORK_ORDER_STATUS:"DASHBOARD_WORK_ORDER_STATUS",
  DASHBOARD_CATEGORY:"DASHBOARD_CATEGORY",
  DEFECT_CAUSE: "DEFECT_CAUSE",
  PRINCIPAL_STATUS_ACTION: "PRINCIPAL_STATUS_ACTION",
  NOTIFICATION_STATUS: "NOTIFICATION_STATUS",
  NOTIFICATION_TRIGGER_TYPE: 'NOTIFICATION_TRIGGER_TYPE',
  USER_ROLE: "USER_ROLE",
  OPERATION_TYPE: "OPERATION_TYPE",
  OPERATION_STATUS: "OPERATION_STATUS",
  TASK_STATUS: "TASK_STATUS",
  IMPERIAL_SYSTEM_UNITS: 'IMPERIAL_SYSTEM_UNITS',
  INVENTORY_DASHBOARD_GENERAL_TIME_PERIOD: 'INVENTORY_DASHBOARD_GENERAL_TIME_PERIOD',
  INVENTORY_DASHBOARD_TIME_PERIOD: 'INVENTORY_DASHBOARD_TIME_PERIOD',
  PRIORITY_TYPE: 'PRIORITY_TYPE',
  TELEMETRY_UOM_TEMPERATURE: 'TELEMETRY_UOM_TEMPERATURE',
  TELEMETRY_UOM_HUMIDITY: 'TELEMETRY_UOM_HUMIDITY',
  TELEMETRY_SENSOR_TYPE: 'TELEMETRY_SENSOR_TYPE',
  TELEMETRY_UOM: 'TELEMETRY_UOM',
  AUTOMATION_TYPE: 'AUTOMATION_TYPE',
  LOCATION_TYPE: 'LOCATION_TYPE',
  TOOL_USABILITY_TYPE: 'TOOL_USABILITY_TYPE',
  TEMPERATURE_UNITS: 'TEMPERATURE_UNITS',
  LENGTH_UNITS: 'LENGTH_UNITS',
  WIDTH_UNITS: 'WIDTH_UNITS',
  AREA_UNITS: 'AREA_UNITS',
  WEIGHT_UNITS: 'WEIGHT_UNITS',
  VISCOSITY_UNITS: 'VISCOSITY_UNITS',
  VOLUME_UNITS: 'VOLUME_UNITS',
  HOME_PAGE_TYPE: 'HOME_PAGE_TYPE',
  SHIPMENT_STATUS: 'SHIPMENT_STATUS',
  SCHEDULER_WARNING_TYPE: 'SCHEDULER_WARNING_TYPE',
  SCHEDULING_TRIGGER_CYCLE: 'SCHEDULING_TRIGGER_CYCLE',
  SCHEDULING_TRIGGER_TYPE: 'SCHEDULING_TRIGGER_TYPE',
  TOOL_CONFIGURATION_TYPE: 'TOOL_CONFIGURATION_TYPE',
  SENSOR_PROVIDER_TYPE: 'SENSOR_PROVIDER_TYPE',
  OVERALL_PASS_CRITERIA: 'OVERALL_PASS_CRITERIA',
  PASS_CRITERIA: 'PASS_CRITERIA',
  COC_TEST_RESULT: 'COC_TEST_RESULT',
  TEST_TYPE: 'TEST_TYPE',
  QPL_ATTACHMENT_TYPE: 'QPL_ATTACHMENT_TYPE',
  FREQUENCY_VALUE: 'FREQUENCY_VALUE',
  LOT_STATUS: 'LOT_STATUS',
  TOOL_MAINTENANCE_TYPE: 'TOOL_MAINTENANCE_TYPE',
  ATTACHMENT_CATEGORY: 'ATTACHMENT_CATEGORY',
  PICK_LIST_STATUS: 'PICK_LIST_STATUS',
  FEEDBACK_REASON_TYPE: 'FEEDBACK_REASON_TYPE',
  SUPPLIER_ORGANIZATION_STATUS: 'SUPPLIER_ORGANIZATION_STATUS',
};

// hierarchyLevel - first level equals 1 (only one parent: TOP LEVEL)
export function getLookupOptions(type, parent = undefined, hierarchyLevel = undefined) {
  if (!enums) {
    console.error("enumsHelper: no enums found");
  }
  let results = enums?.lookups[type] || [];

  if (parent) {
    results = results.filter(lookup => {
      return lookup.parents.includes(parent);
    });
  }

  if (hierarchyLevel != undefined) {
    results = results.filter(lookup => {
      return lookup.parents.length === hierarchyLevel;
    });
  }
  return results;
}

export function getEnumValue(type) {
  return (value) => {
    if (!enums) {
      console.error("enumsHelper: enum didn't found");
      return {};
    }
    let match = enums.enums[type];
    if (!match) {
      console.error("enumsHelper: enum type didnt found " + type);
      return {};
    }

    if (!match[value]) {
      console.error(`enumsHelper: enum value didnt found ${type} -> ${value}`);
      return null;
    }

    return match[value];
  }
}

export function getEnumLabel(type) {
  return (value) => {
    if (!enums) {
      console.error("enumsHelper: enum didn't found");
      return "";
    }
    let match = enums.lookups[type];
    if (!match) {
      console.error("enumsHelper: enum type didnt found " + type);
      return "";
    }

    let found = match.find(lookup => lookup.value == value);

    if (!found) {
      console.error(`enumsHelper: enum value didnt found ${type} -> ${value}`);
      return "";
    }

    return found.label;
  }
}

export function enumToDropdownOptions(enumType) {
  if (!enums?.enums?.hasOwnProperty(enumType)) {
    console.error(`missing enums or enum type ${enumType}`, enums);
    return [];
  }
  let res = [];
  let keys = Object.keys(enums.enums[enumType]);
  for (let i in keys) {
    let key = keys[i];
    res.push({ label: getEnumLabel(enumType)(key), value: key })
  }
  return res;
}
